import React, {useContext} from 'react';
import { ExhibitorContext } from "../../context/exhibitor";

export default function useExhibitorData() {
	const [ exhibitorProfile, setExhibitorProfile ] = useContext(ExhibitorContext);

	return [ exhibitorProfile, setExhibitorProfile ];
}